/* unplugin-vue-components disabled */import { render } from "./logistics_detail.vue?vue&type=template&id=46f4b45d&scoped=true"
import script from "./logistics_detail.vue?vue&type=script&lang=js"
export * from "./logistics_detail.vue?vue&type=script&lang=js"

import "./logistics_detail.vue?vue&type=style&index=0&id=46f4b45d&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f4b45d"]])

export default __exports__